import React from "react";
import * as S from "./style";

function Banner() {
  return (
    <S.Wrapper>
      <img src="/images/banner.png" alt="배너" />
    </S.Wrapper>
  );
}

export default Banner;
